
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VisaTravelTips from "../pages/visa-travel-tips/page";
import VisaUSGuide from "../pages/visa-us-guide/page";
import CarRentalGuide from "../pages/car-rental-guide/page";
import TravelInsuranceGuide from "../pages/travel-insurance-guide/page";
import MoneySavingTips from "../pages/money-saving-tips/page";
import TravelBudget from "../pages/travel-budget/page";
import PackingChecklist from "../pages/packing-checklist/page";
import FamilyTravelTips from "../pages/family-travel-tips/page";
import NewYorkAttractions from "../pages/new-york-attractions/page";
import OutletShoppingGuide from "../pages/outlet-shopping-guide/page";
import AmericanFoodGuide from "../pages/american-food-guide/page";
import PublicTransportGuide from "../pages/public-transport-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/visa-travel-tips",
    element: <VisaTravelTips />,
  },
  {
    path: "/visa-us-guide",
    element: <VisaUSGuide />,
  },
  {
    path: "/car-rental-guide",
    element: <CarRentalGuide />,
  },
  {
    path: "/travel-insurance-guide",
    element: <TravelInsuranceGuide />,
  },
  {
    path: "/money-saving-tips",
    element: <MoneySavingTips />,
  },
  {
    path: "/travel-budget",
    element: <TravelBudget />,
  },
  {
    path: "/packing-checklist",
    element: <PackingChecklist />,
  },
  {
    path: "/family-travel-tips",
    element: <FamilyTravelTips />,
  },
  {
    path: "/new-york-attractions",
    element: <NewYorkAttractions />,
  },
  {
    path: "/outlet-shopping-guide",
    element: <OutletShoppingGuide />,
  },
  {
    path: "/american-food-guide",
    element: <AmericanFoodGuide />,
  },
  {
    path: "/public-transport-guide",
    element: <PublicTransportGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
